import React from "react";

const FlujoServicio = () => {
  return (
    <div className="w-full h-screen overflow-y-hidden">
      <iframe
        src="/pdf/flujo-trabajo.pdf"
        className="w-full h-full"
        title="Visor PDF"
      />
    </div>
  );
};

export default FlujoServicio;
